import React, { useCallback, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import {
  swalErrorMessage,
  swalWarningMessage,
} from "../../../Constant/swalMessage";
import useDebounce from "../../Hooks/useDebounce";
import CommonModal from "../CommonComponents/Modal/CommonModal";
import { getAllCustomersAction } from "../Customer/Store/customers.action";
import {
  chatTestAgentAction,
  editAgentAction,
  getAgentAction,
} from "../ProjectSection/Agents/Store/Agent.action";
import TestAgentBody from "./TestAgentBody";

const TestAgent = ({
  testAgentModal,
  selectedAgent,
  toggle,
  toggleTestAgentPopup = () => {},
}) => {
  const dispatch = useDispatch();
  const { projectId } = useParams<{ projectId: string }>();
  const reducer: any = useSelector((state) => state);
  const {
    AccountReducer: { whitelabelDetails },
    CallSettingReducer: { callSettings },
  } = reducer;

  const [nameData, setNameData] = useState<any>({});
  const [state, setState] = useState({
    customerProfiles: [],
    filteredCustomerProfiles: [],
    selectedCases: [],
    dataLoading: false,
    buttonLoading: false,
    generateLoading: false,
    searchText: "",
  });

  const {
    selectedCases,
    buttonLoading,
    generateLoading,
    customerProfiles,
    searchText,
  } = state;
  const [modelState, setModelState] = useState({
    model: callSettings?.model || "001",
  });
  const { model } = modelState;
  const debouncedSearchTerm = useDebounce(searchText, 2000);

  useEffect(() => {
    setNameData(whitelabelDetails?.nameChanges || {});
  }, [whitelabelDetails]);

  useEffect(() => {
    const searchTerm = (debouncedSearchTerm || "").trim().toLowerCase();

    if (!searchTerm) {
      updateState({ filteredCustomerProfiles: customerProfiles });
      return;
    }

    const filtered = (customerProfiles || []).filter((item: any) => {
      const name = String(item?.customerName || "").toLowerCase();
      if (name.includes(searchTerm)) return true;

      const userFields = item?.userFields;
      if (userFields && typeof userFields === "object") {
        const hasMatch = Object.values(userFields).some((val) => {
          if (val === null || val === undefined) return false;
          return String(val).toLowerCase().includes(searchTerm);
        });
        if (hasMatch) return true;
      }

      return false;
    });

    updateState({ filteredCustomerProfiles: filtered });
  }, [debouncedSearchTerm, customerProfiles]);

  const updateState = (updates) =>
    setState((prev) => ({ ...prev, ...updates }));

  const getTestCustomers = useCallback(async () => {
    updateState({ dataLoading: true });
    try {
      const params = {
        pageIndex: 1,
        pageSize: 1000,
      };
      const res: any = await dispatch(getAllCustomersAction(params));

      if (res && Array.isArray(res)) {
        updateState({
          customerProfiles: res,
          filteredCustomerProfiles: res,
          dataLoading: false,
        });
      } else {
        updateState({
          customerProfiles: [],
          filteredCustomerProfiles: [],
          dataLoading: false,
        });
      }
    } catch (err) {
      updateState({ dataLoading: false });
    }
  }, [dispatch]);

  useEffect(() => {
    getTestCustomers();
  }, [dispatch, getTestCustomers]);

  const startTestAgent = async () => {
    if (!selectedCases.length) {
      swalWarningMessage("Please select at least one customer profile.");
      return;
    }

    updateState({ buttonLoading: true });
    const { _id: agentId, objections } = selectedAgent;

    const customerIds = selectedCases?.map((sel: any) => sel?._id);

    const obj = {
      agentId,
      projectId,
      customerIds,
      customerModel: model,
      agentModel: callSettings?.model,
      conversationLimit: 25,
      custom_fields: {},
    };
    const res: any = await dispatch(chatTestAgentAction(obj));

    if (res?.status === 202) {
      toggle();
      toggleTestAgentPopup();
    } else {
      swalErrorMessage("Something went wrong");
    }

    updateState({ buttonLoading: false });
  };

  const testAgentObj = {
    state,
    updateState,
    setModelState,
    nameData,
    model,
  };

  return (
    <>
      <CommonModal
        heading="Test Agent"
        body={<TestAgentBody testAgentObj={testAgentObj} />}
        show={testAgentModal}
        toggle={toggle}
        handleSave={startTestAgent}
        size={customerProfiles?.length === 0 ? 800 : 1100}
        spin={buttonLoading}
        disableSaveButton={generateLoading || customerProfiles?.length === 0}
        saveButtonText="Start Testing"
      />
    </>
  );
};

export default TestAgent;
